{{#foreach handle.identifier iterationPropertiesList}}
  {{> (partial "snippets/new-object") handle=handle iterationPropertiesList=iterationPropertiesList.next}}
{{else}}
{{#with handle}}
{{ identifier }}{{ iterationPropertiesList.last.brackets }} = new({{#if hasDimensions }}$sformatf("{{ identifier }}{{ uvcOrEnvInstance.formatBrackets }}", {{#each iterationPropertiesList.last.iterationVariables delimeter=", "}}{{ . }}{{/each}}){{else}}"{{ identifier }}"{{/if}}, this);
{{/with}}
{{/foreach}}
